import { produce } from 'immer';
import {
  GRIDEABLE_SUCCESS,
  GRIDEABLE_FAILURE,
  GRIDEABLE_REQUEST,
  GRIDEABLE_SET_SEARCH_FIELDS,
  GRIDEABLE_SET_ORDER,
  GRIDEABLE_SET_TIENDA_ID_FILTER,
  GRIDEABLE_INIT,
} from '../actions/constants/grideable.constants';

const initialState = {
  usuarios: {
    running: null,
    datos: [],
    success: null,
  },
};

const initialGrideable = {
  running: null,
  datos: [],
  success: null,
  pagination: null,
};

export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  const { endpoint } = payload || { endpoint: undefined };
  if (endpoint) {
    if (draft[endpoint] === undefined) draft[endpoint] = { ...initialGrideable };
  }
  switch (type) {
    case GRIDEABLE_REQUEST: {
      const {
        endpoint,
        pagination,
      } = payload;
      draft[endpoint].running = true;
      draft[endpoint].success = null;
      if (pagination !== undefined) {
        draft[endpoint].pagination = pagination;
      }
      return draft;
    }
    case GRIDEABLE_SET_TIENDA_ID_FILTER: {
      const { tiendaId, endpoint } = payload;
      draft[endpoint].tiendaId = tiendaId;
      return draft;
    }
    case GRIDEABLE_SUCCESS: {
      const {
        datos, endpoint, pagination,
      } = payload;
      //
      draft[endpoint].datos = datos;
      draft[endpoint].running = false;
      draft[endpoint].success = true;
      draft[endpoint].pagination = pagination;
      break;
    }
    case GRIDEABLE_FAILURE: {
      const {
        endpoint,
      } = payload;
      draft[endpoint].running = false;
      draft[endpoint].success = false;
      break;
    }
    case GRIDEABLE_SET_SEARCH_FIELDS: {
      const { filters, endpoint } = payload;
      Object.keys(filters).forEach((key) => {
        if (draft[endpoint].filters == undefined) draft[endpoint].filters = {};
        if (filters[key] == undefined) {
          delete draft[endpoint].filters[key];
        } else {
          draft[endpoint].filters[key] = filters[key];
        }
      });
      break;
    }
    case GRIDEABLE_SET_ORDER: {
      const { order, endpoint } = payload;
      draft[endpoint].sorter = order;
      break;
    }
    case GRIDEABLE_INIT: {
      const { endpoint } = payload;
      draft[endpoint] = { ...initialGrideable };
      break;
    }
    default:
      return draft;
  }
});
